'use strict'; // socket.io-pull-stream

var Queue = require('data-queue');

var uuid = require('uuid');

var pull = require('pull-stream');

var sioname = function sioname(type, name) {
  return 'socket.io-pull-stream.' + type + (name ? '.' + name : '');
};

var debug = require('debug');

var _log = debug('socket.io-pull-stream');

function doCodec(codec, data) {
  if (data == null) return data;

  try {
    return codec(data);
  } catch (e) {
    console.error('Codec Error');
    console.error(e);
    return false;
  }
}

var codecs = {
  hex: {
    encode: function encode(v) {
      return v.toString('hex');
    },
    decode: function decode(v) {
      return Buffer.from(v, 'hex');
    }
  },
  plain: {
    encode: function encode(v) {
      return v;
    },
    decode: function decode(v) {
      return v;
    }
  },
  buffer: {
    // always do Buffer.from because browsers
    encode: function encode(v) {
      return Buffer.from(v);
    },
    decode: function decode(v) {
      return Buffer.from(v);
    }
  }
};

function getCodec(c) {
  if (!c) c = 'plain';
  if (typeof c === 'object') return c;
  var co = codecs[c];
  if (!co) throw new Error('Invalid codec ' + c);
  return co;
}

function SIOSource(sio, id, opt) {
  var q = Queue();
  var log = sio.sioplog.bind(sio.sioplog, 'source(' + id + ')');
  var codec = getCodec(opt.codec).decode;
  log('create source');
  sio.emit(sioname('accept', id));

  function unlisten() {
    sio.removeAllListeners(sioname('error', id));
    sio.removeAllListeners(sioname('queue', id));
  }

  sio.on(sioname('error', id), function (err) {
    if (err === true) log('finish');else log('error');
    unlisten();
    q.append({
      end: err
    });
  });
  sio.on(sioname('queue', id), function (data) {
    log('queue data');
    q.append({
      data: doCodec(codec, data)
    });
  });
  sio.once('disconnect', function () {
    unlisten();
    q.append({
      end: true
    });
  });
  return function (end, cb) {
    log('reading');
    if (end) return cb(end);
    q.get(function (err, data) {
      if (err) return cb(err);

      if (data.end) {
        q.error(data.end);
        return cb(data.end);
      }

      return cb(null, data.data);
    });
  };
}

function SIOSink(sio, id, opt) {
  var q = Queue();
  var log = sio.sioplog.bind(sio.sioplog, '  sink(' + id + ')');
  var codec = getCodec(opt.codec).encode;
  var ended;
  log('create sink');
  sio.once(sioname('accept', id), function () {
    log('start transmission');

    function loop() {
      q.get(function (_, val) {
        var _ref = val || {},
            data = _ref.data,
            err = _ref.err;

        if (_) err = _;
        log('send', err && err === true ? 'finish' : err ? 'error' : data ? 'data' : '<invalid>');
        if (err && !_) q.error(err);
        if (err) return sio.emit(sioname('error', id), err);
        if (data) sio.emit(sioname('queue', id), doCodec(codec, data));
        loop();
      });
    }

    loop();
  });

  function doErr(end) {
    q.append({
      err: end
    });
    ended = end;
  }

  sio.once('disconnect', function () {
    return doErr(true);
  });
  return function (read) {
    read(null, function next(end, data) {
      if (end) return doErr(end);
      if (ended) return read(ended, next);
      q.append({
        data: data
      });
      read(null, next);
    });
  };
}

module.exports = function SIOPullStream(sio, opt) {
  if (sio.createSink) return;
  sio.sioplog = sio.id ? _log.bind(_log, '[' + sio.id + ']') : _log;

  sio.createSink = function (id, _) {
    if (!id) id = uuid();
    var sink = SIOSink(sio, id, opt || _);
    sink.id = id;
    return sink;
  };

  sio.createSource = function (id, _) {
    var source = SIOSource(sio, id, opt || _);
    source.id = id;
    return source;
  };

  sio.createProxy = function (id, tsio, _) {
    pull(sio.createSource(id, _), tsio.createSink(id, _));
  };
};